import classnames from "classnames"
import icons from "feather-icons/dist/feather-sprite.svg"

import styles from "./Icon.module.scss"

const OWN_ICONS = [
  "scooter",
  "sort_ascending",
  "sort_descending",
  "sort_inactive",
  "chart",
  "navigation_report",
  "sales_plan",
  "sales_plan_light",
]
const OTHER_ICONS = ["navigation_scooter", "navigation_quotation", "navigation_claim"]
const NAV_ICONS = [
  "navigation_feedback",
  "navigation_feedbackReport",
  "navigation_reception",
  "navigation_SvpStoreSettings",
  "navigation_dailyOperationReport",
  "navigation_svd-general-service-packages",
  "navigation_svd-customer-care-service-packages",
  "navigation_svd-maintenance-service-packages",
  "navigation_svd-monthly-payment-scooters",
  "navigation_reconciliationList",
  "navigation_uploadORCR",
  "navigation_coupons",
  "navigation_promotions",
]

type IconProps = {
  icon?: any
  className?: string
  style?: React.CSSProperties
}

const Icon = ({ icon, className, style }: IconProps) => {
  if (OWN_ICONS.includes(icon) || NAV_ICONS.includes(icon)) {
    return (
      <img className={className} src={`${process.env.PUBLIC_URL}/images/icons/${icon}.svg`} style={style} alt={icon} />
    )
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={classnames(styles.container, className)}
      style={style}>
      <use
        xlinkHref={
          OTHER_ICONS.includes(icon) ? `${process.env.PUBLIC_URL}/images/icons/${icon}.svg#icon` : `${icons}#${icon}`
        }
      />
    </svg>
  )
}

export default Icon
